import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import { RemoveScroll } from 'react-remove-scroll';

import {
    Breakpoint,
    BREAKPOINTS
} from 'tradera/components/breakpoint/breakpoint';
import {
    EnterFrom,
    EnterFade
} from 'tradera/components/transitions/transitions';
import ApplicationErrorBoundary from 'tradera/components/application-error-boundary/application-error-boundary';
import { Overlay } from 'tradera/components/scrollable-modal/overlay';
import { ProfileMenuContent } from './profile-menu-content';
import { SignInMenuContent } from './sign-in-menu-content';
import { useAppSelector } from 'tradera/state/hooks';

type ProfileMenuProps = {
    expanded: boolean;
    handleExpand: () => void;
    transparentHeader: boolean;
};

export const ProfileMenu = ({
    expanded,
    handleExpand,
    transparentHeader
}: ProfileMenuProps) => {
    const { isLoggedIn } = useAppSelector((state) => state.member);

    const renderChild = () => (
        <RemoveScroll forwardProps>
            <div className="site-dropdown profile-menu">
                {isLoggedIn ? (
                    <ProfileMenuContent />
                ) : (
                    <SignInMenuContent closeMenu={handleExpand} />
                )}
            </div>
        </RemoveScroll>
    );

    return (
        <ApplicationErrorBoundary>
            <nav role="navigation">
                <TransitionGroup component={null} mountOnEnter>
                    {expanded && (
                        <EnterFade in={expanded}>
                            <Overlay
                                style={{
                                    zIndex: 4,
                                    top: transparentHeader ? '0' : '3.5rem',
                                    height: transparentHeader
                                        ? '100vh'
                                        : 'calc(100vh - 3.5rem)'
                                }}
                                closeModalCallback={handleExpand}
                            />
                        </EnterFade>
                    )}

                    {expanded && (
                        <EnterFrom from="right" in={expanded}>
                            <Breakpoint upTo={BREAKPOINTS.LG}>
                                {renderChild()}
                            </Breakpoint>
                        </EnterFrom>
                    )}
                </TransitionGroup>
                {expanded && (
                    <Breakpoint is={BREAKPOINTS.XL}>{renderChild()}</Breakpoint>
                )}
            </nav>
        </ApplicationErrorBoundary>
    );
};
